// https://developers.themoviedb.org/

module.exports = {
  APIKey: 'fe948b32120519f42ab283f800b989c8'
}